import moment from 'moment';
import { getMeetingReport, getMeetingReportDownLoad } from '../services/report';

export default {
  namespace: 'meetingReport',
  state: {
    startTime: moment(),
    endTime: moment().add(7,'days'),
    userName: '',
    pageNo: 1,
    pageSize: 10,
    searchData: []
  },
  reducers: {
    setState(state, { payload }) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *search(undefined, { call, select, put }) {
      const { locale } = yield select(state => state.i18n);
      const { token } = yield select(state => state.login);
      let startTime = yield select(state => state.meetingReport.startTime);
      let endTime = yield select(state => state.meetingReport.endTime);
      let userName = yield select(state => state.meetingReport.userName);
      let pageNo = yield select(state => state.meetingReport.pageNo);
      let pageSize = yield select(state => state.meetingReport.pageSize);

      let data = yield call(getMeetingReport, {
        startDate: startTime.startOf('day').valueOf(),
        endDate: endTime.endOf('day').valueOf(),
        userName,
        locale,
        pageNo,
        pageSize,
        token
      });
      if (data) {
        yield put({
          type: 'setState',
          payload: { searchData: data.data || [] }
        });
      }
    },
    *changePage({ payload }, { call, select, put }) {
      yield put({ type: 'setState', payload: { ...payload } });
      const { locale } = yield select(state => state.i18n);
      const { token } = yield select(state => state.login);
      let startTime = yield select(state => state.meetingReport.startTime);
      let endTime = yield select(state => state.meetingReport.endTime);
      let userName = yield select(state => state.meetingReport.userName);
      let pageNo = yield select(state => state.meetingReport.pageNo);
      let pageSize = yield select(state => state.meetingReport.pageSize);
      let data = yield call(getMeetingReport, {
        startDate: startTime.startOf('day').valueOf(),
        endDate: endTime.endOf('day').valueOf(),
        userName,
        locale,
        pageNo,
        pageSize,
        token
      });
      if (data) {
        yield put({
          type: 'setState',
          payload: { searchData: data.data || [] }
        });
      }
    },
    *downloadRoom({}, { select, call }) {
      const { locale } = yield select(state => state.i18n);
      const { token } = yield select(state => state.login);
      let startTime = yield select(state => state.meetingReport.startTime);
      let endTime = yield select(state => state.meetingReport.endTime);
      let userName = yield select(state => state.meetingReport.userName);
    
      yield call(getMeetingReportDownLoad, {
        startDate: startTime.startOf('day').valueOf(),
        endDate: endTime.endOf('day').valueOf(),
        userName,
        locale,
        token
      });
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(rooter => {
        if (rooter.pathname.indexOf('meetingReport') > -1) {
          dispatch({ type: 'setState',payload : {startTime: moment(), endTime: moment().add(7,'days'), userName: '',pageNo: 1}});
          dispatch({ type: 'search'});
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/meetingReport.js